import { useIsBelowMantineBreakpoint } from '../use-is-below-mantine-breakpoint';

/**
 * If the screen width the device is below mantine's sm breakpoint
 */
const useIsMobile = (): boolean => {
  return useIsBelowMantineBreakpoint('sm');
};

export default useIsMobile;
